import React, { FC, useCallback, useRef } from 'react';
import axios from 'axios';
import { LobIcon, Time, redirectTo } from 'omni-package-react-core';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import MoreMenu from './MoreMenu';
import { Notification as NotificationInterface } from '../../../../../../../interfaces/Notification';
import {
  StyledLink, StyledLeftCol,
  StyledLobIcon, StyledNotification, StyledNotificationText,
  StyledNotificationTextSection, StyledRightCol, StyledTime, StyledLobDiv,
} from './Details.styles';
import NotificationType from './NotificationType';
import getNotificationsApiRoot from '../../../../../../../utils/getNotificationsApiRoot';
import putReminder from '../../../../../../../utils/putReminder';
import { removeNotification, setIsDeleting, setNotificationsIsOpened } from '../../../../../../../actions/Notifications.actions';

export interface DetailsProps {
  notification: NotificationInterface;
}
const Details: FC<DetailsProps> = ({ notification }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const notificationClick = useCallback(() => {
    if (notification.source === 'notification') {
      axios.patch(
        `${getNotificationsApiRoot()}/${encodeURIComponent(notification.id)}`,
        {
          notificationId: notification.id,
          visited: true,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      ).catch(() => {
        // we don't catch those errors
      }).finally(() => {
        window.location.href = notification.url;
      });
    } else if (notification.source === 'promotion') {
      putReminder(notification.id)
        .catch(() => { /* we do not catch those errors */ })
        .finally(() => {
          redirectTo(notification.url, navigate);
          dispatch(setNotificationsIsOpened());
          dispatch(setIsDeleting(notification.id, true));
          dispatch(removeNotification(notification.id));
        });
    }
  }, [notification.source, notification.id, notification.url, navigate, dispatch]);

  const linkRef = useRef(null);

  if (notification.isDeleting) return null;
  const className = notification?.visited === false ? 'unvisited' : '';

  return (
    <StyledNotification
      href={notification.url}
      tabIndex={0}
      onKeyDown={(x) => {
        if (document.activeElement === linkRef.current && x.code === 'Enter') {
          notificationClick();
        }
      }}
      onClick={(x) => { x.preventDefault(); }}
      className={className}
      data-testid={notification.id}
      ref={linkRef}
    >
      <StyledLink onClick={notificationClick}>
        <StyledLobIcon>
          <NotificationType type={notification.type} />
          <StyledLobDiv withType={notification.type !== 'information'}>
            <LobIcon code={notification.sector} />
          </StyledLobDiv>
        </StyledLobIcon>
        <StyledLeftCol xs={8.1} sm={8.1} md={8.1} lg={8.3}>
          <StyledNotificationTextSection>
            <StyledNotificationText className={className}>{notification.text}</StyledNotificationText>
            <StyledTime className={className}>
              <Time time={new Date(notification.creationDateUtc)} />
            </StyledTime>
          </StyledNotificationTextSection>
        </StyledLeftCol>
      </StyledLink>
      <StyledRightCol>
        {notification.type !== 'actionrequired' && <MoreMenu id={notification.id} />}
      </StyledRightCol>
    </StyledNotification>
  );
};
export default Details;
